import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Popup, Icon } from 'semantic-ui-react';
import { TextField, Checkbox } from 'material-ui';
import { ButtonLink, LoginTemplate, Logo, Button, Loading } from 'components';

import classNames from 'classnames/bind';
import styles from './Register.css';
const cx = classNames.bind(styles);

class Register extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      isLoading,
      userEmailError,
      userPasswdError,
      repeatPasswdError,
      userNameError,
      userPhoneError,
      serviceNameError,
      agreeError,
      registerData,
      userChange,
      validate,
      keyPress,
      signUp
    } = this.props;

    const extraArea = (
      <div className={cx('extra-area')}>
        <div className={cx('ctregister-extra')}>
          {defineMessages(formatMessage({ id: 'Register_1', defaultMessage: '이미 계정이 있으신가요?' })) + ' '}
          <div className={cx('inline-block')}>
            <ButtonLink
              activeOnlyWhenExact={false}
              to="/login"
              label={defineMessages(formatMessage({ id: 'Register_2', defaultMessage: '로그인' }))}
            />
          </div>
        </div>
      </div>
    );

    return (
      <LoginTemplate extraArea={extraArea}>
        <div className={cx('ctregister-wrapper')}>
          {/* <div
            className={cx('color-red')}
            style={{
              width: '445px',
              textAlign: 'left',
              marginBottom: '35px',
              display: 'flex'
            }}>
            <div>
              <Icon name="info circle" />
              현재는 BETA 테스트 기간이며 서비스 정보, 훈련 결과 등 모든 데이터가 1일 단위로 초기화 되니 유의하시기
              바랍니다.
            </div>
          </div> */}
          {isLoading && (
            <div className={cx('Loading')}>
              <Loading content={'Loading...'} />
            </div>
          )}
          {/* 서비스 가입 영역 */}
          <div className={cx('input-field')}>
            {/*validation set 1*/}
            <TextField
              label={defineMessages(formatMessage({ id: 'Register_3', defaultMessage: '이메일' }))}
              className={cx('register-input', userEmailError && userEmailError !== true ? 'error' : null)}
              fullWidth
              name="userEmail"
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="off"
            />
            {/*validation set 2*/}
            {userEmailError === true && <Icon name="checkmark" />}
          </div>
          {/*validation set 3*/}
          <div className={cx('error-message')}>{userEmailError && userEmailError !== true && userEmailError}</div>
          <div className={cx('input-field')}>
            <TextField
              label={defineMessages(formatMessage({ id: 'Register_4', defaultMessage: '비밀번호' }))}
              className={cx('register-input', userPasswdError && userPasswdError !== true ? 'error' : null)}
              fullWidth
              type="password"
              name="userPasswd"
              ref={Input => {
                this.userPasswdInput = Input;
              }}
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="new-password"
            />
            {userPasswdError === true && <Icon name="checkmark" />}
          </div>
          <div className={cx('error-message')}>
            {userPasswdError &&
              userPasswdError !== true &&
              Array.isArray(userPasswdError) &&
              userPasswdError.map((errorDetail, index) => {
                return <div key={index}>{errorDetail}</div>;
              })}
          </div>
          <div className={cx('input-field')}>
            <div className={cx('left-text')} />
            <TextField
              label={defineMessages(formatMessage({ id: 'Register_5', defaultMessage: '비밀번호 재확인' }))}
              className={cx('register-input', repeatPasswdError && repeatPasswdError !== true ? 'error' : null)}
              fullWidth
              type="password"
              name="repeatPasswd"
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="new-password"
            />
            {repeatPasswdError === true && <Icon name="checkmark" />}
          </div>
          <div className={cx('error-message')}>
            {repeatPasswdError && repeatPasswdError !== true && repeatPasswdError}
          </div>
          <div className={cx('input-field')}>
            <TextField
              label={defineMessages(formatMessage({ id: 'Register_6', defaultMessage: '이름' }))}
              className={cx('register-input', userNameError && userNameError !== true ? 'error' : null)}
              fullWidth
              name="userName"
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="off"
            />
            {userNameError === true && <Icon name="checkmark" />}
          </div>
          <div className={cx('error-message')}>{userNameError && userNameError !== true && userNameError}</div>
          <div className={cx('input-field')}>
            <TextField
              label={defineMessages(formatMessage({ id: 'Register_14', defaultMessage: '연락처' }))}
              className={cx('register-input', userPhoneError && userPhoneError !== true ? 'error' : null)}
              fullWidth
              name="userPhone"
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="off"
            />
            {userPhoneError === true && <Icon name="checkmark" />}
          </div>
          <div className={cx('error-message')}>{userPhoneError && userPhoneError !== true && userPhoneError}</div>
          <div className={cx('input-field')}>
            <TextField
              className={cx('register-input', serviceNameError && serviceNameError !== true ? 'error' : null)}
              label={defineMessages(formatMessage({ id: 'Register_8', defaultMessage: '서비스명' }))}
              fullWidth
              name="serviceName"
              onChange={userChange}
              onBlur={validate}
              onKeyPress={keyPress}
              autoComplete="off"
            />
            {serviceNameError === true && <Icon name="checkmark" className={cx('mr-20')} />}
            <Popup className="max-250" trigger={<i className={cx('info circle icon link')} />} position="bottom left">
              {defineMessages(
                formatMessage({
                  id: 'Register_9',
                  defaultMessage: '서비스의 관리 및 공유를 위한 서비스명은 필수 입력 사항입니다'
                })
              )}
            </Popup>
          </div>
          {!(serviceNameError && serviceNameError !== true) && (
            <div className={cx('service-notice')}>
              {defineMessages(
                formatMessage({
                  id: 'Register_13',
                  defaultMessage: '회사명, 소속, 부서 등 원하는 서비스명을 자유롭게 입력하세요.'
                })
              )}
            </div>
          )}
          <div className={cx('error-message')}>{serviceNameError && serviceNameError !== true && serviceNameError}</div>
          <div className={cx('agree-area')}>
            <Checkbox
              className={cx('white', agreeError && 'error')}
              name="agree"
              onChange={userChange}
              onBlur={validate}
            />
            <label className={cx('agreeMessage')}>
              {defineMessages(formatMessage({ id: 'Register_10', defaultMessage: '약관을 읽었으며 이에 동의합니다.' }))}
            </label>
            <a href={'/tos_' + localStorage.getItem('language') + '.html'} target="_blank">
              {defineMessages(formatMessage({ id: 'Register_11', defaultMessage: '이용약관' }))}
            </a>
          </div>
          <div className={cx('error-message last')}>{agreeError ? agreeError : null}</div>
          <div className={cx('button-area')}>
            <Button className={cx('bt-signUp')} loading={registerData.loading} onClick={signUp}>
              {defineMessages(formatMessage({ id: 'Register_12', defaultMessage: '가입하기' }))}
            </Button>
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

export default injectIntl(Register);



// WEBPACK FOOTER //
// ./src/script/components/register/Register.js